import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { Seo } from '@/components/marketing/Seo';
import { AlphabetBoard } from '@/components/alphabet/AlphabetBoard';
import { localAlphabet, type AlphabetLetter } from '@/content/mobile';
import { track } from '@/lib/analytics';
import { alphabetFlavorCopy, letterAudioSource } from '@/lib/alphabet-sections';
import { playAudio } from '@/lib/play-audio';
import { enqueueActivity } from '@/lib/progress-queue';
import { useLearnerPreferences } from '@/providers/LearnerPreferences';

export const Route = createFileRoute('/app/alphabet')({ component: AlphabetPage });

function AlphabetPage() {
  const { dialect, voice } = useLearnerPreferences();
  const alphabet = localAlphabet(dialect);
  const copy = alphabetFlavorCopy(dialect);
  const [selected, setSelected] = useState<AlphabetLetter | null>(null);

  const choose = (letter: AlphabetLetter) => {
    const source = letterAudioSource(letter, voice);
    if (!source) return;
    setSelected(letter);
    void playAudio(source);
    track('Alphabet Sound Listen', { letter: letter.script, dialect });
    void enqueueActivity('alphabet_sound_listen', {
      script: letter.script,
      pronunciation: letter.pronunciation,
    });
  };

  return (
    <div className="min-h-full bg-[#ECFFE6]">
      <Seo title={`${copy.title} — Hmonglus`} description={copy.description} path="/app/alphabet" />
      <AlphabetBoard
        title={copy.title}
        description={copy.description}
        alphabet={alphabet}
        selected={selected}
        voice={voice}
        onChoose={choose}
      />
    </div>
  );
}
